module.exports = __webpack_public_path__ + "img/chest_active.7c1c962d.png";